import ReviewerRole from './ReviewerRole'

export default class TopReviewer extends ReviewerRole {
  arcDownloadsPerWeek = 50
  totalClaimOverdueDayAllowance = 150
  arcMaxDownloads = -1
  requiredReviewsForTier = 30
  requiredReviewRateForTier = 70
  canMessageAuthor = true
  canDownloadAudioBookArcs = true
}
